import { Component, OnInit,Output,Inject, ViewChild, ElementRef, AfterViewChecked, EventEmitter } from '@angular/core';
import { CPQScreenOption, CPQSelectionSummary, CPQUI } from '../../shared/models/CPQUI';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';

import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalComponent } from '../../shared/components/modal/modal.component';
import { BasePopupComponent } from '../../shared/directives/base-popup.directive';

@Component({
  selector: 'app-cpq',
  templateUrl: './cpq.component.html',
  styleUrls: ['./cpq.component.css']
})
export class CPQComponent extends BasePopupComponent implements OnInit, AfterViewChecked {
  @Output() CloseEventEmitter: EventEmitter<any> = new EventEmitter();
  @Output() ActionEventEmitter: EventEmitter<any> = new EventEmitter();
  @ViewChild("cpqContainer") CPQContainer: ElementRef;
  @ViewChild("cpqDiv") CPQDiv: ElementRef;
  ConfigString: string;
  EnteredCFGString: string;
  CurrentCPQSessionID: string;
  CurrentCPQUI: CPQUI;
  CurrentPrice: number;
  CPQMessages: string;
  ActionButtonDisabled: boolean;
  CloseButtonDisabled: boolean;
  closeHidden: boolean;
  acceptHidden: boolean;
  autoScroll: boolean;
  hideLoadingModal: boolean;
  hideEnteredCFGString: boolean;
  CurrentOpenDialog: MatDialogRef<ModalComponent, any>;
  MessagesForSummary: string[];
  ActionButtonCanClick: boolean;
  ShowMessages: boolean;

  constructor(private http: HttpService, private global: GlobalService, public dialogRef: MatDialogRef<CPQComponent>, @Inject(MAT_DIALOG_DATA) private modalData: any, public matDialog: MatDialog)
  {
    super();
  }

  ngOnInit(): void {
    this.hideLoadingModal = true;
    this.hideEnteredCFGString = false;
    this.MessagesForSummary = [];
    this.ActionButtonDisabled = true;
    this.autoScroll = false;
    this.ActionButtonCanClick = true;
    this.ShowMessages = false;
    this.CPQMessages = "";
    if (this.EnteredCFGString) {
      this.ConfigString = this.EnteredCFGString;
      this.hideEnteredCFGString = true;
    }
    else {
      this.ConfigString = "";
      this.EnteredCFGString = "";
    }
    if (!this.CurrentCPQUI) {
      this.CurrentCPQUI = new CPQUI();
      this.StartConfiguration();
    }
    else {
      var temp = this.PrepareCPQUIObject(this.CurrentCPQUI);

      temp.Pages[0].Active = true;
      this.CurrentCPQUI = temp;
      this.hideLoadingModal = true;

      this.PullMessagesFromCPQUI(temp);
      this.PullPriceFromCPQUI(temp);
      if (this.CurrentPrice > 0.0) {
        this.ActionButtonDisabled = false;
      }
      this.CheckForRequired(temp);
      if (this.CPQMessages && this.CPQMessages.length > 0 && this.ShowMessages) {
        //Show messages
        this.ShowCPQMessages();
      }
    }
    
  }



  StartConfiguration() {
    this.http.CPQConfigureStart(this.ConfigString, true).then(wrap => {
      this.hideLoadingModal = false;
      this.CurrentCPQSessionID = wrap.Content;
      this.http.CPQInitialize(this.CurrentCPQSessionID).then(wrap2 => {
        this.CurrentCPQSessionID = wrap2.Content;

        this.http.CPQConfigureUpdate(this.CurrentCPQSessionID, "", "").then(wrap3 => {
          var temp = this.PrepareCPQUIObject(<CPQUI>wrap3.Content);

          temp.Pages[0].Active = true;
          this.CurrentCPQUI = temp;
          this.hideLoadingModal = true;
          this.ConfigString = this.getConfigStringFromCPQUI();
          this.PullMessagesFromCPQUI(temp);
          this.PullPriceFromCPQUI(temp);
          
          if (this.CurrentPrice > 0.0) {
            this.ActionButtonDisabled = false;
          }
          this.CheckForRequired(temp);
          if (this.CPQMessages && this.CPQMessages.length > 0 && this.ShowMessages) {
            //Show messages
            this.ShowCPQMessages();
          }
        });
      });
    });
  }

  CheckForRequired(cpq: CPQUI) {
    cpq.Pages.forEach(page => {
      page.Screens.forEach(screen => {
        screen.ScreenOptions.forEach(opt => {
          if (opt.IsRequired && (opt.Value == "")) {
            this.ActionButtonDisabled = true;
          }
          else if (opt.IsValid == false) {
            this.ActionButtonDisabled = true;
          }
        });
      });
    });
  }

  CheckForInvalid() {
    this.CurrentCPQUI.Pages.forEach(page => {
      page.Screens.forEach(screen => {
        screen.ScreenOptions.forEach(opt => {
          if (opt.IsValid == false) {
            this.ActionButtonDisabled = true;
          }
        });
      });
    });
  }

  

  ngAfterViewChecked(): void {
    if (this.autoScroll) {
      this.scrollToBottom();
      this.autoScroll = !this.autoScroll;
    }
  }

  CFGStringEntered() {
    if (this.EnteredCFGString.length > 0) {
      this.EnteredCFGString = this.EnteredCFGString.trim();
      var regEx = new RegExp( /^([\d+]{8})/gi);
      var match = regEx.exec(this.EnteredCFGString);
      if (match) {
        this.ConfigString = match[1];
      }
      else {
        this.ConfigString = this.EnteredCFGString;
      }
      
      this.StartConfiguration();
    }
    
  }

  PrepareCPQUIObject(cpq: CPQUI): CPQUI {

    var index = 0;
    cpq.Pages.forEach(x => {
      x.Index = index;
      x.IsVisible = true;
      x.Screens.forEach(y => {
        y.IsVisible = true;
        y.ScreenOptions.forEach(z => {
          if (z.Caption.toLowerCase() == "enter cfg string?" && z.DisplayType.toLowerCase() == "radiobuttonhorizontal") {
            z.IsVisible = false;
          }
          else {
            z.IsVisible = z.IsVisible;// || (z.IsRequired || z.IsEnabled);// true;
            z.IsValid = true;
          }          
        });
      });
      index++;
    });


    var activePage = this.CurrentCPQUI.Pages.filter(x => x.Active == true);
    var activeIndex = 0;
    if (activePage != null && activePage.length > 0) {
      activeIndex = activePage[0].Index;
    }
    if (activeIndex == 0 && this.CurrentCPQUI && this.CurrentCPQUI.Pages && cpq.Pages.length > this.CurrentCPQUI.Pages.length && cpq.Pages.length > 2) {
      cpq.Pages[2].Active = true;
    }else if (cpq.Pages.length == 2) {
      cpq.Pages[1].Active = true;
    } else if (cpq.Pages.length == 1) {
      cpq.Pages[0].Active = true;
      this.autoScroll = true;
    }
    else {
      
      cpq.Pages[activeIndex].Active = true;
      this.ActionButtonDisabled = false;
      if (activeIndex > 1) {
        this.autoScroll = false;
      }
    }
    return cpq;
  }

  OnPageChange(event: CPQScreenOption) {
    //this.ShowLoadingModal.emit();
    this.hideLoadingModal = false;
    this.http.CPQConfigureUpdate(this.CurrentCPQSessionID, event.ID, event.Value).then(wrapper => {

      var temp1 = <CPQUI>wrapper.Content;
     
        var temp = this.PrepareCPQUIObject(<CPQUI>wrapper.Content);
        //temp = this.RemoveAuxCarrierPage(temp);
        
      this.CurrentCPQUI.Details = temp.Details;
      this.CurrentCPQUI.SelectionSummary = temp.SelectionSummary;
      this.PullMessagesFromCPQUI(temp);
      this.ConfigString = this.getConfigStringFromCPQUI();
      this.CurrentCPQUI.Pages = temp.Pages;

      if (this.CPQMessages && this.CPQMessages.length > 0 && this.ShowMessages) {
        //Show messages
        this.ShowCPQMessages();

      }

        //if (this.StillPickingMotor) {
        //  this.CurrentCPQUI.Pages = temp.Pages;
        //  this.CurrentCPQUI.Pages[0].Active = true;
        //  this.StillPickingMotor = false;
        //}
        //else {
        //  for (var i = 0; i < this.CurrentCPQUI.Pages.length; i++) {
        //    if (i <= temp.Pages.length - 1) {
        //      this.CurrentCPQUI.Pages[i].Screens = temp.Pages[i].Screens;
        //    }
        //  }
        //}

      //this.CurrentCPQUI = this.PrepareCPQUIObject(<CPQUI>wrapper.Content);
      this.PullPriceFromCPQUI(this.CurrentCPQUI);
      if (this.CurrentPrice > 0.0) {
        this.ActionButtonDisabled = false;
      }
      this.CheckForRequired(temp);
      this.CheckForInvalid();
      this.hideLoadingModal = true;
      //this.HideLoadingModal.emit();
    });
  }


  ShowCPQMessages() {
    var dialogConfig = this.GetDialogConfig("CPQMessages");

    var rmaObject = { type: "Messages", object: [this.CPQMessages] };
    dialogConfig.data = rmaObject;

    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);

    this.CurrentOpenDialog.componentInstance.ActionEventEmitter.addListener("actionEvent", (event) => {
      this.CurrentOpenDialog.close();
      this.ShowMessages = false;
    });

    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
      this.CurrentOpenDialog.close();
      this.ShowMessages = false;
    });
  }

  GetDialogConfig(name: string): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = name;
    dialogConfig.height = "50%";
    dialogConfig.width = "50%";

    return dialogConfig;
  }


  scrollToBottom() {
    this.CPQContainer.nativeElement.scrollTop = this.CPQContainer.nativeElement.scrollHeight;
  }

  PullPriceFromCPQUI(cpq: CPQUI) {
    debugger;
    var priceDetails = cpq.Details.filter(x => x.Caption.toLowerCase().indexOf('price') >= 0);
    var totalPrice = 0.0;
    //priceDetails.forEach(price => {
    //  totalPrice += this.ParseCurrency(price.Value, 2);
    //});

    //this.CurrentPrice = totalPrice;
    var lastPrice = priceDetails[priceDetails.length - 1];
    if (lastPrice && lastPrice.Value) {
      this.CurrentPrice = this.ParseCurrency(lastPrice.Value, 2);
      //this.ActionButtonDisabled = false;
    }
    else {
      this.CurrentPrice = 0;
    }
  }

  getConfigStringFromCPQUI(): string {
    var config = "";

    if (this.CurrentCPQUI && this.CurrentCPQUI.Details && this.CurrentCPQUI.Details.length > 0) {
      var filtered = this.CurrentCPQUI.Details.filter(x => x.Caption.toLowerCase() == "config string")[0];
      if (filtered) {
        config = filtered.Value;
      }
    }

    if (config == "") {
      config = this.ConfigString;
    }

    return config;
  }

  ParseCurrency(str: string, precision: number) {
    return Number(str.slice(0, (str.indexOf('.')) + precision + 1));
  }

  PullMessagesFromCPQUI(cpq: CPQUI) {
    debugger;
    var messages = "";
    var dupeCheck = [];
    this.MessagesForSummary = [];
    for (var i = 0; i < cpq.Messages.length; i++) {
      if (cpq.Messages[i].Value.indexOf("Note:") >= 0) {
        if (dupeCheck.filter(x => x == cpq.Messages[i].Value).length == 0) {
          if (cpq.Messages[i].Value.toLowerCase().indexOf('config string') < 0) {
            messages += cpq.Messages[i].Value + "\r\n";
            dupeCheck.push(cpq.Messages[i].Value);
          }
        }
      }
    }

    var htmlRegex = /[<].*?[>]/g;//new RegExp('[<].*[>]');

    messages = messages.replace(htmlRegex, '');

    messages = messages.trimLeft();
    if (messages.length != this.CPQMessages.length) {
      this.CPQMessages = messages;
      this.ShowMessages = true;
    }
    

    for (var i = 0; i < dupeCheck.length; i++) {
      if (this.MessagesForSummary.filter(x => x == dupeCheck[i].toString()).length == 0) {
        this.MessagesForSummary.push(dupeCheck[i]);
      }
    }
  }

  StripHTML(dirty: string) {
    var htmlRegex = /[<].*?[>]/g;//new RegExp('[<].*[>]');

    dirty = dirty.replace(htmlRegex, '');

    return dirty;
  }

  closeMethod() {
    this.CloseEventEmitter.emit("closeEvent");
  }

  actionMethod() {
    if (this.ActionButtonCanClick == true) {
      this.hideLoadingModal = false;
      this.ActionButtonCanClick = false;
      this.PullPriceFromCPQUI(this.CurrentCPQUI);
      var configString = this.getConfigStringFromCPQUI();
      var selectionSummary = this.getSelectionSummaryFromCPQUI();

      this.ActionEventEmitter.emit({ "CurrentPrice": this.CurrentPrice, "configString": configString, "selectionSummary": selectionSummary });
      this.hideLoadingModal = true;
    }
    
  }

  GetCSSClass(id: number) {
    var classString = "";
    if (this.CurrentCPQUI.Pages[id] || (id > 0 && this.CurrentCPQUI.Pages[id - 1])) {
      classString = "active"
    }
    else {
      if (id == 0)
        classString = "active";
      else
        classString = "inactive"
    }

    if (this.CurrentCPQUI.Pages[id].Active == true)
      classString += " current";
    return classString;
  }


  GetNavCSSClass(id: number) {
    //var classString = "";
    //if (this.CurrentCPQUI.Pages[id] || (id > 0 && this.CurrentCPQUI.Pages[id - 1])) {
    //  classString = "active"
    //}
    //else {
    //  if (id == 0)
    //    classString = "active";
    //  else
    //    classString = "inactive"
    //}

    //if (this.CurrentCPQUI.Pages[id].Active == true)
    //  classString += " link-active";
    //return classString;
    var classString = "";
    if (this.CurrentCPQUI.Pages.length > 0) {
      if (this.CurrentCPQUI.Pages.length + 1 == id) {
        classString = ",'active',";
        classString += ",'link-active'";
      } else {
        if (this.CurrentCPQUI.Pages[id] || (id > 0 && this.CurrentCPQUI.Pages[id - 1])) {
          classString = ",'active'";
        }
        else {
          if (id == 0)
            classString = ",'active'";
          else
            classString = ",'inactive'";
        }

        if (this.CurrentCPQUI.Pages[id].Active == true)
          classString += " ,'link-active','current'";
      }

    }
    return classString;
  }

  OptionHeader_Click(id: number) {
    this.CurrentCPQUI.Pages.forEach(x => {
      x.Active = false;
    });
    this.CurrentCPQUI.Pages[id].Active = true;
  } 

  getSelectionSummaryFromCPQUI(): string {
    debugger;
    var summary = "";
    //var selectionArray = [];
    //this.CurrentCPQUI.SelectionSummary.forEach(ss => {
    //  if ((ss.Caption && ss.Value) && ss.Caption.length > 0 && ss.Value.length > 0 && (ss.Value != "No" && ss.Value != "None" && ss.Value != "False")) {
    //    var newSum = new CPQSelectionSummary();
    //    newSum.Caption = this.stripTags(ss.Caption);
    //    newSum.Value = ss.Value;
    //    selectionArray.push(newSum);
    //  }
    //});

    this.CurrentCPQUI.Details.forEach(detail => {

      if (detail.Caption.toLowerCase().indexOf("selection summary") < 0 && detail.Caption.indexOf("Note:") < 0 && detail.Caption.toLowerCase().indexOf("price") < 0 && detail.Value == "" && detail.Caption.length > 0) {
        summary += "<span>" + this.stripTags(detail.Caption) + "</span><br />";
      }
    });

    if (this.MessagesForSummary.length > 0) {
      for (var i = 0; i < this.MessagesForSummary.length; i++) {
        summary += "<span>" + this.MessagesForSummary[i] + "</span><br />";
      }
    }

    return summary;
  }

  stripTags(input: string): string {
    return input.replace(/(<([^>]+)>)/gi, "");
  }
}
